<template>
  <v-app class="entrada-salida">
    <header class="pl-13 v-app-bar" style="background: #fff;">
      <div class="v-toolbar__content" style="height: 56px;">
        <div elevation="0" class="pl-0 header-icon">
          <v-icon class="icon caja"></v-icon>
        </div>
      </div>
    </header>
    <Menu />
     
    <v-main class="background">

      <div class="mx-auto my-auto">
          <router-link class="mx-auto d-flex" :to="{ name: 'SalidasAlbaranes', query: { modo: 'salida' } }" v-if="permitido('MOBILESTORE.PHONESERVICES.SALIDAS') || permitido('MOBILESTORE.PHONESERVICES.PEDIDOS')"> 
            <v-btn large class="primary "
            >
              <v-icon class="mr-3 ">mdi-file-document-outline</v-icon>
              Salida por ODT / Albaran
            </v-btn>
          </router-link>

          <router-link class="d-flex  mt-6" :to="{ name: 'SalidasManual'}" v-if="permitido('MOBILESTORE.PHONESERVICES.SALIDAS') || permitido('MOBILESTORE.PHONESERVICES.PEDIDOS')"> 
            <v-btn large
            class="primary col-12"
            >
            <v-icon class="mr-3 ">mdi-archive-outline</v-icon>
              Salida manual
            </v-btn>
          </router-link>
     </div>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import Menu from '../../components/Menu.vue';

export default Vue.extend({
  name: 'Profile',
  components: {
    Menu
  },
  data: () => ({
    codOdt: ''
  }),
  beforeCreate () {
    this.$root.$emit('verificarCertificado', location.href)
  },
  mounted() {
    
  },
  methods: {
  },
});
</script>
